import { useEffect, useState } from 'react';
import { healthcareRatesGateway } from './index';
import { ORIGINAL_SERVICE_PAY_BASES, offeredServicePayBases, type PayBasis } from './types';

/**
 * The pay bases a rate or pay-run line form offers. The original five are always offered. A newer basis (per mile, per trip, ...) appears only after
 * Payroll Calculation reports it can price it, so a screen never offers a basis whose rate payroll could not use. While the list loads, or when it cannot
 * be read (a person without rate access, a service that is down), only the original five are offered; the server still refuses anything it cannot price.
 */
export function useSupportedPayBases(): readonly PayBasis[] {
  const [bases, setBases] = useState<readonly PayBasis[]>(ORIGINAL_SERVICE_PAY_BASES);
  useEffect(() => {
    const controller = new AbortController();
    healthcareRatesGateway
      .listSupportedPayBases(controller.signal)
      .then((names) => { if (!controller.signal.aborted) setBases(offeredServicePayBases(names)); })
      .catch(() => { if (!controller.signal.aborted) setBases(ORIGINAL_SERVICE_PAY_BASES); });
    return () => controller.abort();
  }, []);
  return bases;
}
